module.exports = __webpack_public_path__ + "static/media/gear_color.43d436ea.png";